import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { GlobalService } from './global.service';

import 'rxjs/add/operator/filter';

@Injectable( )
export class LoginService {



  // userInfo: CurrentUserInfo;
  userInfo: any = {};
  isLogged: boolean = false;


  // List of available URLs for unlogged users
  availableURLs: string[] = [ '/login' ];


  constructor ( 
    public global: GlobalService,
    private router: Router ) {


    // Check if user has local storage session
    router.events
      .filter( event => event instanceof NavigationEnd )
      .subscribe( ( event: NavigationEnd ) => {
        this.checkLocalStorage( );
      });
      
  }



  checkStatus ( ) {    
    if ( this.userInfo.status == 'active' ) {
      if ( this.userInfo.fresh_login ) this.router.navigate(['/confirm-registration']);
      // else this.router.navigate(['/']);
    } else this.router.navigate(['/not-allowed']);
  }


  // Checking local storage
  checkLocalStorage ( ) {

    let _currentUser = localStorage.getItem( 'currentUser' );

    if ( _currentUser ) {
      _currentUser = JSON.parse( _currentUser );
      this.userInfo = _currentUser;
      this.isLogged = true;
      this.checkStatus( );
    } else {
      if ( this.isLogged ) this.logout( );
      else if ( this.availableURLs.indexOf( this.router.url ) == -1 ) this.router.navigate(['/login']);
    }

  }



  // If user log In on production
  loginProd ( login, password, cb ) {

    let data: string = JSON.stringify({ "email": login, "password": password });
    this.global.postRequest( 'authenticate', data, false,  ( data ) => {
      data = data.json( );
      if ( data.token && data.role ) {
        cb( data.token, data.role, data.status, data.fresh_login );
      } else {
        cb( '', '', '', 0 );
      }
    });

  }



  // Log In user
  login ( login, password, success, error, caller ) {

    let _validLogin;
    let _inner = ( token, role, status, fresh_login ) => {

      if ( token ) {

        this.isLogged = true;
        this.userInfo.login = login;
        this.userInfo.password = password;
        this.userInfo.token = token;
        this.userInfo.role = role;
        this.userInfo.status = status;
        this.userInfo.fresh_login = fresh_login;
        localStorage.setItem( 'currentUser', 
          JSON.stringify({ 
            login: this.userInfo.login, 
            token: this.userInfo.token, 
            role: this.userInfo.role, 
            fresh_login: this.userInfo.fresh_login, 
            status: this.userInfo.status  
          }) 
        );
        this.checkLocalStorage( );
        if ( status == 'active' ) {
          if ( fresh_login ) this.router.navigate(['/confirm-registration']);
          else this.router.navigate(['/']);
        } else this.router.navigate(['/not-allowed']);
        // Callback when success
        if ( this.global.isFunction ( success ) ) success( caller );
      } else {

        // Callback when error
        if ( this.global.isFunction ( error ) ) error( caller );
      }

    }

    this.loginProd ( login, password, ( token, role, status, fresh_login ) => {
      _inner( token, role, status, fresh_login );
    });

  }



  // Return information if user is Logged In
  check ( ) {
    return this.isLogged;
  }



  // Registration of user
  registration ( login, password ) {
  }





  // Logout user
  logout ( ) {
    this.isLogged = false;
    localStorage.removeItem( 'currentUser' );
    localStorage.removeItem( 'scrollProductsList' );
    localStorage.removeItem( 'scrollAdminDashboard' );
    localStorage.removeItem( 'paginationProductsList' );
    localStorage.removeItem( 'filtersProductsList' );
    localStorage.removeItem( 'paginationAdminDashboard' );
    localStorage.removeItem( 'sortingAdminDashboard' );
    localStorage.removeItem( 'filtersAdminDashboard' );
    localStorage.removeItem( 'paginationAdminDashboard' );
    localStorage.removeItem( 'sortingReferrerDashboard' );
    localStorage.removeItem( 'filtersReferrerDashboard' );
    localStorage.removeItem( 'paginationReferrerDashboard' );
    this.checkLocalStorage( );
    this.router.navigate(['/login']);
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/services/login.service.ts